var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nb-badge d-flex justify-content-center",class:`nb-badge-${this.type}`},[(_vm.icon)?_c('i',{staticClass:"alert-icon",class:`${this.icon} text-${this.type}`}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }